// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3B6Ax","productName":"Table_productName__3BhvH"};